import React from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as LogoutIcon } from '@/assets/icons/logout.svg';
import { TitleButtonProp } from '@/layout/components/TitleButton';
import { logout } from '@/model/global/actions';

export interface LogoutButtonProps {
  className?: string;
}

export const LogoutButton: TitleButtonProp = ({ className }: LogoutButtonProps) => {
  const dispatch = useDispatch();
  return (
    <LogoutIcon
      onClick={async (): Promise<void> => {
        await logout()(dispatch);
      }}
      className={className}
    />
  );
};

export default LogoutButton;
